import { FieldValues } from 'common/apps/modules/form/types';
import { AffiliateUser, User } from 'types/user';

const isUserAffiliate = (user: User | FieldValues): user is AffiliateUser =>
  !!user.isAffiliate;

export default isUserAffiliate;
